import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMapPin = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#map-pin-clip)",
		children: /* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinejoin: "round",
			d: "M2 6.628C2 3.52 4.686 1 8 1s6 2.52 6 5.628c0 1.936-1.014 3.726-2.136 5.123-1.129 1.405-2.418 2.475-3.078 2.983a1.295 1.295 0 0 1-1.572 0c-.66-.508-1.95-1.578-3.078-2.983C3.014 10.354 2 8.564 2 6.628Zm3.656 0C5.656 5.414 6.706 4.43 8 4.43s2.344.984 2.344 2.198S9.294 8.827 8 8.827s-2.344-.985-2.344-2.199Z",
			clipRule: "evenodd"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "map-pin-clip",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgMapPin;
